// this function is equivalent to that which 'computed' function in instance of Vue

export default {
}
